import { useState } from "react";

import { IconButton, Tooltip } from "@mui/material";
import ScienceOutlinedIcon from "@mui/icons-material/ScienceOutlined";

import { Device } from "types/Device";
import { DeviceDiagnosticsDialog } from "./DeviceDiagnosticsDialog";

export interface OpenDeviceDiagnosticsButtonProps {
    device: Device;
    diagnosticsCorrelationId: string;
}

export function OpenDeviceDiagnosticsButton(
    props: OpenDeviceDiagnosticsButtonProps,
) {
    const [showDeviceDiagnosticsDialog, setShowDeviceDiagnosticsDialog] =
        useState(false);

    return (
        <>
            <Tooltip title="Open device diagnostics">
                <IconButton
                    disabled={!props.diagnosticsCorrelationId}
                    onClick={() => {
                        setShowDeviceDiagnosticsDialog(true);
                    }}
                >
                    <ScienceOutlinedIcon />
                </IconButton>
            </Tooltip>

            {props.diagnosticsCorrelationId && showDeviceDiagnosticsDialog && (
                <DeviceDiagnosticsDialog
                    device={props.device}
                    diagnosticsCorrelationId={props.diagnosticsCorrelationId}
                    closeDialog={() => {
                        setShowDeviceDiagnosticsDialog(false);
                    }}
                />
            )}
        </>
    );
}
